import React from 'react';
import { HeaderFilterTable } from '@/components/common';
import { Options } from '@/components/ui/combobox';
import { useApplyFilterMultiple } from '@/hooks/filters/useApplyFilterMultiple';

interface Props {
	disabled?: boolean;
}

export const DocumentType: React.FC<Props> = ({ disabled }) => {
	const { selected, hasFilter, handleClearAll, handleSelectFilters } =
		useApplyFilterMultiple({ filterKey: 'document_types' });

	const data: Options[] = [
		{
			label: 'Requested Document',
			value: 'DOCUMENT',
		},
		{
			label: 'Retainer',
			value: 'RETAINER',
		},
		{
			label: 'Signature',
			value: 'SIGNATURE',
		},
	];

	return (
		<HeaderFilterTable
			title="Document Type"
			searchTitle="Document Type"
			type="multiple"
			values={selected}
			filterOptions={data}
			handleClearAll={handleClearAll}
			handleSelectFilters={handleSelectFilters}
			hasFilter={hasFilter('document_types')}
			classNamePopoverContent="lg:w-[302px]"
			buttonContentDefault={false}
			disabled={disabled}
		/>
	);
};
